import React from "react";
import PlayerRankingContent from "../components/player_ranking/player_ranking_main_section";
import { Box } from "@mui/material";
function PlayerRanking() {
  return (
    <Box
      sx={{
        width: "100%",
        minHeight: "100vh",
        // border: "1px solid white",
        display: "flex",
        alignItems: "center",
        flexDirection: "column",
        justifyContent: "center",
        overflowX: "auto",
        overflowY: "visible",
      }}
    >
      <PlayerRankingContent />
    </Box>
  );
}

export default PlayerRanking;
